<template>
    <v-dialog max-width="500px" v-model="show">
        <v-card>
            <v-card-title class="headline">Arrange Meeting</v-card-title>
            <v-card-text class="pb-0">
                <p>
                    Use the form below to schedule a meeting with a group of people. If you are doing a task that requires you to
                    make a meeting, select the task below.
                </p>

                <v-alert type="warning">
                    Ensure that you have planned your meeting with others (i.e. asking them verbally).
                    If people are already in a meeting or decline your meeting invitation, you will still lose
                    {{ meetingLength }} action points and the meeting will not proceed.
                </v-alert>

                <v-select :items="eligibleTasks" label="Task" item-text="title" return-object v-model="selectedTask"/>

                <p v-if="selectedTask">
                    <b>Your selected task requires {{ this.selectedTask.with ? this.selectedTask.with.length : "0" }} people to sit in for this meeting.</b>
                    You may add additional people below:
                </p>
                <p v-else>
                    You will be doing a meeting that will not contribute to any of your tasks. Select which people you would
                    like to attend your meeting below:
                </p>
            </v-card-text>
            <v-list-item dense v-for="player in nonAttendees" :key="player.id">
                <v-list-item-content>
                    <v-list-item-title>
                        {{ player.name }}
                    </v-list-item-title>
                </v-list-item-content>
                <v-list-item-action>
                    <v-btn outlined color="primary" x-small @click="addAttendee(player)">
                        Add
                    </v-btn>
                </v-list-item-action>
            </v-list-item>
            <v-card-text class="pb-0">
                <p>The following people will be invited to attend this meeting:</p>
            </v-card-text>
            <v-list-item dense v-for="attendee in allAttendees" :key="attendee.id">
                <v-list-item-content>
                    <v-list-item-title>
                        {{ attendee.name }}
                        <v-chip color="primary" x-small v-if="attendee.required">required</v-chip>
                    </v-list-item-title>
                    <v-list-item-subtitle v-if="attendee.note">{{ attendee.note }}</v-list-item-subtitle>
                </v-list-item-content>
                <v-list-item-action v-if="!attendee.required">
                    <v-btn outlined color="red" x-small @click="removeAttendee(attendee)">
                        Remove
                    </v-btn>
                </v-list-item-action>
            </v-list-item>
            <v-card-text>
                This meeting will be {{ meetingLength }} minutes in length and will <b>cost {{ meetingLength }} action points</b>.
            </v-card-text>
            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn text @click="show = false">Close</v-btn>
                <v-btn text color="primary" @click="createMeeting()">Create Meeting</v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
import { mapState } from 'vuex';

export default {
    props: {
        value: Boolean,
        action: Object
    },
    computed: {
        show: {
            get() {
                return this.value;
            },
            set(value) {
                return this.$emit("input", value);
            }
        },
        meetingLength() {
            return this.selectedTask.length || 1;
        },
        eligibleTasks() {
            var output = [
                {
                    id: null,
                    title: "== NO TASK =="
                }
            ];

            if (!this.tasks) { return output; }
            const taskList = Object.values(this.tasks).filter(task => task.action == "meeting" && !task.complete);
            return output.concat(taskList);
        },
        nonAttendees() {
            return this.players.filter((p) => !this.attendeeIds.includes(p.id) && p.id !== this.playerId)
        },
        attendeeIds() {
            return this.allAttendees.map(function(p) {
                return p.id
            });
        },
        allAttendees() {
            return this.requiredAttendees.concat(this.attendees);
        },
        requiredAttendees() {
            if (!this.selectedTask || !this.selectedTask.with) { return [] }

            return this.selectedTask.with.map(function(pl) {
                return {
                    "id": pl.id,
                    "name": pl.name,
                    "note": pl.role.name || null,
                    "required": true
                }
            })
        },
        ...mapState({
            tasks: state => state.tasks,
            players: state => state.players,
            playerId: state => state.playerId
        })
    },
    data: () => ({
        selectedTask: {
            id: null,
            title: "== NO TASK =="
        },
        attendees: []
    }),
    methods: {
        addAttendee(p) {
            this.attendees.push({
                "id": p.id,
                "name": p.name,
                "required": false
            })
        },
        removeAttendee(p) {
            this.attendees = this.attendees.filter((a) => a !== p)
        },
        createMeeting() {
            this.$socket.client.emit("meeting", {
                action: "create",
                taskId: this.selectedTask.id,
                attendees: this.allAttendees
            });
        }
    }
}
</script>
